import styled, { DefaultTheme } from 'styled-components';
import { colors } from '@/theme/lib';

export const getThemeTokens = (theme: DefaultTheme) =>
  ({
    zsl: {
      labelColor: colors.honeyBee,
      textColor: colors.white,
      arrowColor: colors.white,
      backgroundColor: colors.panther,
      borderColor: colors.honeyBee,
      iconColor: colors.honeyBee,
    },
    london: {
      labelColor: colors.black,
      textColor: colors.black,
      arrowColor: colors.black,
      backgroundColor: colors.white,
      borderColor: colors.gecko,
      iconColor: colors.gecko,
    },
    whipsnade: {
      labelColor: colors.black,
      textColor: colors.black,
      arrowColor: colors.black,
      backgroundColor: colors.white,
      borderColor: colors.tiger,
      iconColor: colors.tiger,
    },
    bicentenary: {
      labelColor: colors.black,
      textColor: colors.black,
      arrowColor: colors.black,
      backgroundColor: colors.white,
      borderColor: colors.black,
      iconColor: colors.black,
    },
  })[theme.key] ?? {
    labelColor: colors.black,
    textColor: colors.black,
    arrowColor: colors.black,
    backgroundColor: colors.white,
    borderColor: colors.gecko,
    iconColor: colors.gecko,
  };

export const StyledIconLegendWrapper = styled.section`
  border-radius: 1.25rem;
  background-color: ${(props) => getThemeTokens(props.theme).backgroundColor};
  border: 1px solid ${(props) => getThemeTokens(props.theme).borderColor};
  width: 100%;
  padding: 1.5rem;
  box-sizing: border-box;
`;

export const StyledIconLegendToggle = styled.button`
  background: none;
  border: none;
  outline: none;
  position: relative;
  display: flex;
  align-items: start;
  gap: 0.5rem;

  color: ${(props) => getThemeTokens(props.theme).labelColor};

  font-family: ${(props) => props.theme.fonts.button};
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1.2;
  text-transform: uppercase;
  text-align: left;
  cursor: pointer;

  width: 100%;
  padding: 0 2rem 0 0;

  &::after {
    content: '';
    position: absolute;
    top: calc(50% - 4.5px);
    right: 0.25rem;
    width: 16px;
    height: 9px;
    background-color: ${(props) => getThemeTokens(props.theme).arrowColor};
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    -webkit-mask-size: contain;
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: contain;
  }

  &[aria-expanded='true']::after {
    -webkit-mask-image: url('/Accordion/arrow-up.svg');
    mask-image: url('/Accordion/arrow-up.svg');
  }

  &[aria-expanded='false']::after {
    -webkit-mask-image: url('/Accordion/arrow-down.svg');
    mask-image: url('/Accordion/arrow-down.svg');
  }

  svg {
    color: ${(props) => getThemeTokens(props.theme).iconColor};
  }

  &.with-icon > div {
    gap: 0;
  }
`;

export const StyledIconLegend = styled.ul`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1.5rem;

  list-style: none;

  margin: 0;
  width: 100%;

  &.is-open {
    margin-top: 0.75rem;
  }
`;

export const StyledIconLegendGrid = styled.ul<{ $columns: number }>`
  display: grid;
  grid-template-columns: repeat(${(props) => props.$columns}, 1fr);
  gap: 2rem;

  list-style: none;

  margin: 0;
  width: 100%;

  &.is-open {
    margin-top: 2rem;
  }

  li {
    align-items: start;
  }
`;

export const StyledIconLegendItem = styled.li`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  svg {
    flex-shrink: 0;
    color: ${(props) => getThemeTokens(props.theme).iconColor};
  }

  &.with-icon > div {
    gap: 0;
  }
`;

export const StyledIconLegendDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const StyledIconLegendLabel = styled.span`
  color: ${(props) => getThemeTokens(props.theme).labelColor};
  font-family: ${(props) => props.theme.fonts.button};
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1.2;
  text-transform: uppercase;
`;

export const StyledIconLegendInfo = styled.span`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  color: ${(props) => getThemeTokens(props.theme).textColor};
  font-family: ${(props) => props.theme.fonts.body};
  font-size: 1.125rem;
  font-weight: 400;
  line-height: 1.4;
  text-transform: none;

  div.icon-status {
    display: none;
    width: 14px;
    height: 14px;
    border-radius: 0.25rem;
  }

  div.icon-status-open {
    display: block;
    background-color: ${colors.seagrass};
  }
  div.icon-status-coming-soon {
    display: block;
    background-color: ${colors.honeyBee};
  }
  div.icon-status-passed {
    display: block;
    background-color: ${colors.redPanda};
  }

  div.legend-item-info {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    br {
      display: none;
    }
  }
`;
